import { withNamespaces } from "react-i18next"
import { RiBarChartBoxLine, RiInformationLine } from "react-icons/ri"
import { Card, CardBody, Col, Row, UncontrolledTooltip } from "reactstrap"
import Accordion from 'react-bootstrap/Accordion';

const FinancialRatios = ({
    t,
    detailsQuery,
    setActiveAccordion,
    activeAccordion
}) => {
    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    const {
        current_ratio,
        quick_ratio
    } = organizationData || {};

    return (
        <Accordion.Item 
            onClick={() => setActiveAccordion('financial-ratios')}
            className={activeAccordion === 'financial-ratios' ? 'active' : ''}
            eventKey={'financial-ratios'}
        >
            <Accordion.Header>
                <RiBarChartBoxLine size="24" className="me-2" />
                <span>
                    {t('Financial Ratios')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <Card className="h-100 h-100 shadow-sm">
                    <CardBody className="p-1">
                        <Row>
                            <Col xs='12' className="mb-2">
                                <Row className="align-items-center py-1">
                                    <Col xs='12' md='3' lg="3" xl="2" className="d-flex align-items-center">
                                        <div className="fw-bold text-muted">
                                            {t('Current Ratio')}
                                            <span
                                                id="tooltip-financial_current_ratio"
                                                className="ms-1"
                                                style={{ cursor: "pointer" }}>
                                                <RiInformationLine />
                                            </span>
                                            <UncontrolledTooltip
                                                target="tooltip-financial_current_ratio"
                                            >
                                                {t('Current Assets divided by Current Liabilities.')}
                                            </UncontrolledTooltip> 
                                        </div>
                                    </Col>
                                    <Col xs='12' md='9' lg="9" xl="10" className="text-start">
                                        <div className="fw-bold">
                                            {current_ratio ?? '—'}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                            <Col xs='12' className="mb-2">
                                <Row className="align-items-center py-1">
                                    <Col xs='12' md='3' lg="3" xl="2" className="d-flex align-items-center">
                                        <div className="fw-bold text-muted">
                                            {t('Quick Ratio')}
                                            <span
                                                id="tooltip-financial_quick_ratio"
                                                className="ms-1"
                                                style={{ cursor: "pointer" }}>
                                                <RiInformationLine />
                                            </span>
                                            <UncontrolledTooltip
                                                target="tooltip-financial_quick_ratio"
                                            >
                                                {t('Cash plus Accounts Receivable divided by Current Liabilities.')}
                                            </UncontrolledTooltip>
                                        </div>
                                    </Col>
                                    <Col xs='12' md='9' lg="9" xl="10" className="text-start">
                                        <div className="fw-bold">
                                            {quick_ratio ?? '—'}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    FinancialRatios
)